export default "__VITE_ASSET__fe113648__"